import { ChevronDown } from "lucide-react";
import { Card, Accordion} from "react-bootstrap";
import React from 'react';

const CourseSidebar = () => {
    const subjects = [
        {
          title: "Python Essential (2022)",
          missedLectures: "2 Lectures Missed",
          date: "Sep 25, 2023",
          sections: [
            {
              title: "More On Data Types",
              items: ["Introduction", "Basic Types"]
            },
            {
              title: "OOPs in Python",
              items: ["Classes", "Objects"]
            }
          ]
        },
        {
          title: "JavaScript Fundamentals (2023)",
          missedLectures: "1 Lecture Missed",
          date: "Oct 12, 2023",
          sections: [
            {
                title: "Variables and Data Types",
                items: ["Var", "Let", "Const"]
              },
              {
                title: "Functions in JavaScript",
                items: ["Function Declaration", "Arrow Functions"]
              },
              {
                title: "Loops in JavaScript",
                items: ["For Loop", "While Loop", "Do-While Loop"]
              },
              {
                title: "JavaScript Objects",
                items: ["Object Literals", "Methods", "This Keyword"]
              }
          ]
        }
      ];
      return (
          <div className="container-fluid">
            {subjects.map((subject, subjectIndex) => (
              <Card className="shadow-sm mt-2" key={subjectIndex}>
                <Card.Header className="p-3 border-bottom border-gray-200 d-flex justify-content-between align-items-start">
                  <h2 className="fs-4 fw-medium mb-0">{subject.title}</h2>
                  <p className="fs-7 mb-3 text-dark">{subject.date}</p>
                  <span className="badge bg-danger rounded-pill p-2">{subject.missedLectures}</span>
                </Card.Header>
                <Card.Body className="p-3 text-start">
                  <Accordion defaultActiveKey="0">
                    {subject.sections.map((section, sectionIndex) => (
                      <Accordion.Item eventKey={String(sectionIndex)} key={sectionIndex}>
                        <Accordion.Header>
                          <div className="d-flex align-items-center gap-2">
                            <ChevronDown className="h-4 w-4 text-gray-500" />
                            {section.title}
                          </div>
                        </Accordion.Header>
                        <Accordion.Body>
                          <ul className="list-unstyled mb-0">
                            {section.items.map((item, itemIndex) => (
                              <li key={itemIndex} className="text-sm text-dark">
                                {item}
                              </li>
                            ))}
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </Card.Body>
              </Card>
            ))}
          </div>
      );
}

export default CourseSidebar;
